// src/data/hospitalData.js
import consultorioImg1 from '../imagenes/consultorioCiudad1.webp'; 
import consultorioImg2 from '../imagenes/consultorioOfta2.webp.png'; 


export const boletinesData = [
    { id: 1, title: 'Avances en Cardiología - Edición Septiembre', date: '20/09/2025', description: 'Descubra las últimas innovaciones y tratamientos en nuestro departamento de cardiología.', pdfUrl: '#' },
    { id: 2, title: 'Jornada de Prevención de Diabetes', date: '15/08/2025', pdfUrl: '#' },
    { id: 3, title: 'Guía de Nutrición de Verano', date: '01/07/2025', pdfUrl: '#' },
];

export const donacionSangreData = {
    titulo: 'Donación de Sangre: Un Acto que Salva Vidas',
    introduccion: 'Tu donación es fundamental para el tratamiento de muchos pacientes. Informate sobre cómo podés contribuir.',
    requisitos: [
        'Tener entre 18 y 65 años.',
        'Pesar más de 50 kg.',
        'Gozar de buena salud.',
        'Presentar DNI o documento que acredite identidad.',
        'No estar en ayunas.',
    ],
    ubicacion: {
        servicio: 'Hemoterapia',
        sede: 'Sede Central',
        direccion: 'Av. Libertador 950, San Rafael, Mendoza',
        horarios: 'Lunes a Viernes de 8:00 a 12:00 hs',
    }
};

export const preparacionQuirurgicaData = {
    titulo: 'Preparación para tu Intervención Quirúrgica',
    introduccion: 'Seguir estas indicaciones es crucial para garantizar tu seguridad y el éxito del procedimiento.',
    preparacionGeneral: {
        titulo: 'Indicaciones Generales',
        puntos: [
            'Ayuno de 8 horas para sólidos y líquidos.',
            'Asistir con un acompañante mayor de edad.',
            'Traer estudios prequirúrgicos completos.',
            'Informar sobre medicación habitual.',
            'No utilizar maquillaje, esmalte de uñas ni joyas.'
        ]
    }
};

export const preparacionEndoscopiaData = {
    titulo: 'Preparación para Estudios Endoscópicos (VEDA / VCC)',
    introduccion: 'Una correcta preparación es esencial para la calidad y seguridad de su estudio. Siga atentamente las instrucciones.',
    veda: {
        titulo: 'Preparación para Videoendoscopía Digestiva Alta (VEDA)',
        puntos: [
            'Ayuno total (sólidos y líquidos) de 8 horas previas al estudio.',
            'Concurrir con un acompañante mayor de edad (excluyente).',
            'Si toma medicación para la presión, puede tomarla con una mínima cantidad de agua.',
            'Suspender antiácidos 24 horas antes.'
        ]
    },
    vcc: {
        titulo: 'Preparación para Videocolonoscopía (VCC)',
        puntos: [
            'El día anterior al estudio: dieta líquida estricta (agua, té, jugos colados, caldos).',
            'Realizar la preparación intestinal con el laxante indicado por su médico, siguiendo las instrucciones al pie de la letra.',
            'Concurrir con un acompañante mayor de edad (excluyente).',
            'No es necesario suspender la medicación habitual, salvo indicación médica.'
        ]
    }
};

export const preparacionCardioData = [
    { id: 1, titulo: 'Ecocardiograma Doppler', descripcion: 'Estudio por ultrasonido que evalúa la estructura y función del corazón.', instrucciones: ['No requiere preparación especial.', 'Traer estudios previos si los tuviera.'] },
    { id: 2, titulo: 'Prueba de Esfuerzo (Ergometría)', descripcion: 'Evalúa la respuesta del corazón al ejercicio físico en una cinta o bicicleta.', instrucciones: ['No realizar ejercicio intenso 12 horas antes.', 'Asistir con ropa y calzado cómodos.', 'Realizar un desayuno o almuerzo ligero 2 horas antes.', 'No fumar 3 horas antes del estudio.'] },
    { id: 3, titulo: 'Holter de Presión / ECG (24hs)', descripcion: 'Monitoreo ambulatorio de la presión arterial o el ritmo cardíaco.', instrucciones: ['Asistir con ropa holgada de dos piezas.', 'No se puede bañar durante las 24 horas que dura el estudio.', 'Realizar actividades diarias de forma normal.'] },
];




export const especialidadesData = {
  titulo: 'Servicios y Especialidades',
  introduccion: 'Conocé la cobertura integral que ofrecemos para cuidarte a vos y a tu familia, con profesionales de primer nivel y atención permanente.',
  serviciosPrincipales: [
    {
      titulo: 'Guardia 24hs',
      descripcion: 'Atención de emergencias todos los días, las 24 horas.',
      icono: 'AlertTriangle'
    },
    {
      titulo: 'Internación Clínica y Quirúrgica',
      descripcion: 'Áreas de internación equipadas para cuidados generales y postoperatorios.',
      icono: 'BedDouble'
    },
    {
      titulo: 'Terapia Intensiva (UTI)',
      descripcion: 'Unidad de cuidados críticos con monitoreo avanzado y personal especializado.',
      icono: 'HeartPulse'
    },
    {
      titulo: 'Guardias Pasivas',
      descripcion: 'Disponibilidad de especialistas para interconsultas y urgencias.',
      icono: 'PhoneCall'
    }
  ],
  listaEspecialidades: [
    "Anatomía Patológica",
    "Cardiología",
    "Cirugía General Ambulatoria",
    "Dermatología",
    "Diabetología",
    "Ecodopler (Ambulatorio e Internación)",
    "Endocrinología",
    "Evaluación Prequirúrgica",
    "Flebología",
    "Fonoaudiología",
    "Gastroenterología",
    "Ginecología y Obstetricia",
    "Hematología",
    "Infectología",
    "Mastología",
    "Nefrología",
    "Neumonología",
    "Neurocirugía",
    "Neurología",
    "Nutrición",
    "Otorrinolaringología",
    "Pediatría",
    "Reumatología",
    "Tratamiento del Dolor",
    "Traumatología (Miembro Superior e Inferior)",
    "Urología",
  ]
};


export const cobertura = [
    { nombre: 'PAMI', logoUrl: '/logos/pami.png' },
    { nombre: 'OSEP', logoUrl: '/logos/osep.png' },
    { nombre: 'OSPRERA', logoUrl: '/logos/osprera.png' },
    { nombre: 'OSPAT', logoUrl: '/logos/ospat.png' },
    { nombre: 'OSPSA', logoUrl: '/logos/ospsa.png' },
    { nombre: 'OSPAV', logoUrl: '/logos/ospav.png' },
    { nombre: 'OSAPM', logoUrl: '/logos/osapm.png' },
    { nombre: 'ANDES SALUD', logoUrl: '/logos/andessalud.png' },
    { nombre: 'OSPACA', logoUrl: '/logos/ospaca.png' },
    { nombre: 'PRENSA', logoUrl: '/logos/prensa.png' },
    { nombre: 'OSJERA', logoUrl: '/logos/osjera.png' },
    { nombre: 'OSPAGA', logoUrl: '/logos/ospaga.png' },
    { nombre: 'SADAIC', logoUrl: '/logos/sadaic.png' },
    { nombre: 'UNIMED', logoUrl: '/logos/unimed.png' },
    { nombre: 'ASISTIR', logoUrl: '/logos/asistir.png' },
    { nombre: 'BIENESTAR SALUD', logoUrl: '/logos/bienestar.png' },
    { nombre: 'SUMA SALUD', logoUrl: '/logos/suma.png' },
];



export const consultoriosData = [
  {
    id: 1,
    nombre: "Consultorios Externos Clinica Ciudad",
    direccion: "Gral. Manuel Belgrano 206, M5602 San Rafael, Mendoza",
    telefono: "0260 44.....",
    horarios: "Lunes a Viernes de 8:00 a 20:00 hs",
    mapaUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3358.606163463571!2d-68.33610978481942!3d-34.60371878046085!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x967907fdfc7b3f1d%3A0x6e56bbab07e16e23!2sGral.%20Manuel%20Belgrano%20206%2C%20M5602%20San%20Rafael%2C%20Mendoza!5e0!3m2!1ses-419!2sar!4v1695667999999!5m2!1ses-419!2sar",
    whatsappNumber: "549260111111", 
     imagenUrl: consultorioImg1,
  },
  {
    id: 2,
    nombre: "Centro Medico Libertador",
    direccion: "Av. El Libertador 257, M5600 San Rafael, Mendoza",
    telefono: "0260 440-2946",
    horarios: "Lunes a Viernes de 8:30 a 20:00 hs",
    mapaUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3358.41353919213!2d-68.3298978!3d-34.6173284!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x967907c66d5b2db5%3A0x5b5d8e2462a9c84f!2sAv.%20El%20Libertador%20257%2C%20M5600%20San%20Rafael%2C%20Mendoza!5e0!3m2!1ses-419!2sar!4v1695667890123!5m2!1ses-419!2sar",
    whatsappNumber: "549260111121",
    imagenUrl: consultorioImg2,
  }
];